var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 34,
    viewBox: "0 0 45 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.144531 33.7422V21.3789C0.144531 15.5195 1.53125 10.8906 4.30469 7.49219C7.11719 4.09375 11.1992 1.86719 16.5508 0.8125V6.90625C12.5664 8.15625 9.89062 10.3047 8.52344 13.3516C7.82031 14.9531 7.52734 16.6133 7.64453 18.332H16.8438V33.7422H0.144531ZM44.3242 6.90625C40.3789 8.11719 37.7227 10.3047 36.3555 13.4688C35.5742 15.1484 35.2617 16.7695 35.418 18.332H44.6172V33.7422H27.918V21.3789C27.918 15.4414 29.3438 10.793 32.1953 7.43359C35.0859 4.07422 39.1289 1.86719 44.3242 0.8125V6.90625Z",
    fill: "#288428"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.e9a42ecdd7168418ab27d19ad70939bd.svg";
export { ForwardRef as ReactComponent };